

// // import React, { useState, useEffect } from 'react';
// // import { Modal, Button, Form, Alert, Badge } from 'react-bootstrap';
// // import { useSearchParams } from 'react-router-dom';
// // import axios from 'axios';
// // import config from '../../Common/Configurations/APIConfig';
// // import DefaultData from '../../Common/CompanyData/DefaultData';
// // import Calendar from 'react-calendar';
// // import 'react-calendar/dist/Calendar.css';
// // import './BookService.css';

// // const BookService = () => {
// //     const [searchParams] = useSearchParams();
    
// //     // ================= DATA STATES =================
// //     const [services, setServices] = useState([]);
// //     const [filteredServices, setFilteredServices] = useState([]);
// //     const [categories, setCategories] = useState([]);
// //     const [salons, setSalons] = useState([]);
    
// //     // ================= FILTER STATES =================
// //     const [selectedCategory, setSelectedCategory] = useState('');
// //     const [selectedSalon, setSelectedSalon] = useState('');
// //     const [searchTerm, setSearchTerm] = useState('');
    
// //     // ================= BOOKING MODAL STATES =================
// //     const [showBookingModal, setShowBookingModal] = useState(false);
// //     const [selectedService, setSelectedService] = useState(null);
// //     const [selectedDate, setSelectedDate] = useState(new Date());
// //     const [availableSlots, setAvailableSlots] = useState([]);
// //     const [selectedTimeSlot, setSelectedTimeSlot] = useState(''); // Stores 24h format for logic
// //     const [bookingNotes, setBookingNotes] = useState('');
// //     const [bookingLoading, setBookingLoading] = useState(false);
    
// //     // ================= CUSTOMER STATES =================
// //     const [customerName, setCustomerName] = useState('');
// //     const [customerEmail, setCustomerEmail] = useState('');
// //     const [customerPhone, setCustomerPhone] = useState('');
// //     const [isLoggedIn, setIsLoggedIn] = useState(false);
// //     const [currentUser, setCurrentUser] = useState(null);
    
// //     // ================= FEEDBACK STATES =================
// //     const [error, setError] = useState('');
// //     const [showConfirmation, setShowConfirmation] = useState(false);
// //     const [bookingConfirmation, setBookingConfirmation] = useState(null);

// //     const THEME_COLOR = '#065f46';
// //     const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

// //     // ================= INITIAL LOAD =================
// //     useEffect(() => {
// //         const salonIdFromUrl = searchParams.get('salonId');
// //         if (salonIdFromUrl) {
// //             setSelectedSalon(salonIdFromUrl);
// //         }
// //         checkAuthStatus();
// //         fetchServices();
// //         fetchCategories();
// //         fetchSalons();
// //     }, [searchParams]);

// //     useEffect(() => {
// //         filterServices();
// //     }, [selectedCategory, selectedSalon, searchTerm, services]);

// //     const checkAuthStatus = () => {
// //         const token = localStorage.getItem('token');
// //         const user = localStorage.getItem('user');
// //         if (token && user) {
// //             setIsLoggedIn(true);
// //             const parsedUser = JSON.parse(user);
// //             setCurrentUser(parsedUser);
// //             setCustomerName(parsedUser.name || '');
// //             setCustomerEmail(parsedUser.email || '');
// //         } else {
// //             setIsLoggedIn(false);
// //             setCurrentUser(null);
// //         }
// //     };

// //     const fetchServices = async () => {
// //         try {
// //             const res = await axios.get(config.APIACTIVEURL + config.GETSERVICETYPE);
// //             if (res.data && res.data.data) {
// //                 setServices(res.data.data.filter(s => s.isActive));
// //             }
// //         } catch (error) { console.error("Error fetching services", error); }
// //     };

// //     const fetchCategories = async () => {
// //         try {
// //             const res = await axios.get(config.APIACTIVEURL + config.GETALLCATEGORIES);
// //             setCategories(res.data || []);
// //         } catch (error) { console.error("Error fetching categories", error); }
// //     };

// //     const fetchSalons = async () => {
// //         try {
// //             const res = await axios.get(config.APIACTIVEURL + "Salon/GetAll");
// //             setSalons(res.data || []);
// //         } catch (error) { console.error("Error fetching salons", error); }
// //     };

// //     const filterServices = () => {
// //         let filtered = [...services];
// //         if (selectedCategory) filtered = filtered.filter(s => s.category === selectedCategory);
// //         if (selectedSalon) {
// //             filtered = filtered.filter(s => String(s.salonId).toLowerCase() === String(selectedSalon).toLowerCase());
// //         }
// //         if (searchTerm) {
// //             const term = searchTerm.toLowerCase();
// //             filtered = filtered.filter(s => 
// //                 s.name.toLowerCase().includes(term) || s.category.toLowerCase().includes(term)
// //             );
// //         }
// //         setFilteredServices(filtered);
// //     };

// //     // ================= BOOKING LOGIC =================

// //     const handleBookClick = async (service) => {
// //         setSelectedService(service);
// //         setError('');
// //         setShowConfirmation(false);
// //         setBookingConfirmation(null);
// //         if (!isLoggedIn) {
// //             setCustomerName(''); setCustomerEmail(''); setCustomerPhone('');
// //         }
// //         await fetchAvailableTimeSlots(service.serviceTypeId, new Date());
// //         setShowBookingModal(true);
// //     };

// //     const fetchAvailableTimeSlots = async (serviceId, date) => {
// //         setAvailableSlots(generateDemoSlots());
// //     };

// //     // --- UPDATED FOR 12-HOUR DISPLAY ---
// //     const generateDemoSlots = () => {
// //         const slots = [];
// //         for (let hour = 9; hour < 20; hour++) {
// //             for (let minute of [0, 30]) {
// //                 const h24 = hour.toString().padStart(2, '0');
// //                 const m = minute.toString().padStart(2, '0');
// //                 const time24 = `${h24}:${m}`; // This stays as the logic value

// //                 // Create the 12-hour label
// //                 const period = hour >= 12 ? 'PM' : 'AM';
// //                 const h12 = hour % 12 || 12;
// //                 const time12 = `${h12.toString().padStart(2, '0')}:${m} ${period}`;

// //                 slots.push({ 
// //                     value: time24, 
// //                     label: time12, 
// //                     available: Math.random() > 0.3 
// //                 });
// //             }
// //         }
// //         return slots;
// //     };

// //     const handleDateChange = async (date) => {
// //         setSelectedDate(date);
// //         if (selectedService) {
// //             await fetchAvailableTimeSlots(selectedService.serviceTypeId, date);
// //         }
// //     };

// //     const validateCustomerDetails = () => {
// //         if (!isLoggedIn) {
// //             if (!customerName.trim()) { setError('Please enter your name'); return false; }
// //             if (!customerEmail.trim()) { setError('Please enter your email'); return false; }
// //             const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// //             if (!emailRegex.test(customerEmail)) { setError('Please enter a valid email'); return false; }
// //         }
// //         return true;
// //     };

// //     // --- INPUT = OUTPUT TIMING FIX ---
// //     const formatToNaiveISO = (date, timeSlot) => {
// //         const year = date.getFullYear();
// //         const month = String(date.getMonth() + 1).padStart(2, '0');
// //         const day = String(date.getDate()).padStart(2, '0');
// //         return `${year}-${month}-${day}T${timeSlot}:00`;
// //     };

// //     const handleBookingSubmit = async (e) => {
// //         e.preventDefault();
// //         setError('');

// //         if (!validateCustomerDetails()) return;
// //         if (!selectedTimeSlot) { setError('Please select a time slot'); return; }

// //         setBookingLoading(true);
// //         try {
// //             const startStr = formatToNaiveISO(selectedDate, selectedTimeSlot);
            
// //             // Calculate end time naive string
// //             const [h, m] = selectedTimeSlot.split(':').map(Number);
// //             const dateCopy = new Date(selectedDate);
// //             dateCopy.setHours(h, m, 0, 0);
// //             const endDateObj = new Date(dateCopy.getTime() + (selectedService.durationMinutes || 60) * 60000);
// //             const endStr = formatToNaiveISO(endDateObj, `${String(endDateObj.getHours()).padStart(2, '0')}:${String(endDateObj.getMinutes()).padStart(2, '0')}`);

// //             const bookingData = {
// //                 salonId: selectedService.salonId,
// //                 serviceTypeId: selectedService.serviceTypeId,
// //                 startTime: startStr,
// //                 endTime: endStr,
// //                 status: "PENDING",
// //                 email: isLoggedIn ? currentUser.email : customerEmail,
// //                 customerName: isLoggedIn ? currentUser.name : customerName,
// //                 notes: bookingNotes,
// //                 ...(customerPhone && { phoneNumber: customerPhone })
// //             };

// //             const response = await axios.post(`${config.APIACTIVEURL}${config.CREATEAPPPOINTMENT}`, bookingData);
            
// //             if (response.data.success) {
// //                 const appointmentData = response.data.data;
                
// //                 // Get the 12hr label for the confirmation screen
// //                 const displayTime = availableSlots.find(s => s.value === selectedTimeSlot)?.label || selectedTimeSlot;

// //                 const bookingDetails = {
// //                     appointmentNo: appointmentData?.appointmentNo || 'N/A',
// //                     serviceName: selectedService.name,
// //                     salonName: appointmentData?.salonName || selectedService.salon?.name || 'Salon',
// //                     staffName: appointmentData?.staffName || 'Not assigned',
// //                     date: selectedDate.toLocaleDateString(),
// //                     time: displayTime, // Show 12hr in confirmation
// //                     duration: selectedService.durationMinutes,
// //                     price: selectedService.price,
// //                     customerName: appointmentData?.customerName || (isLoggedIn ? currentUser.name : customerName),
// //                     customerEmail: appointmentData?.customerEmail || (isLoggedIn ? currentUser.email : customerEmail),
// //                     status: appointmentData?.status || 'PENDING',
// //                     message: response.data.message || 'Appointment booked successfully!'
// //                 };
// //                 setBookingConfirmation(bookingDetails);
// //                 setShowConfirmation(true);
// //                 resetBookingForm();
// //             } else {
// //                 setError(response.data.message || 'Failed to create appointment');
// //             }
// //         } catch (error) {
// //             setError(error.response?.data?.message || 'An error occurred. Please try again.');
// //         } finally {
// //             setBookingLoading(false);
// //         }
// //     };

// //     const resetBookingForm = () => {
// //         setSelectedTimeSlot(''); setBookingNotes(''); setSelectedDate(new Date());
// //         setCustomerName(''); setCustomerEmail(''); setCustomerPhone(''); setError('');
// //     };

// //     const formatPrice = (price) => `${currency} ${price?.toFixed(2) || '0.00'}`;
// //     const tileDisabled = ({ date, view }) => view === 'month' && date < new Date().setHours(0,0,0,0);

// //     return (
// //         <div className="page-content" style={{ paddingTop: "80px" }}>
// //             <div className="container-fluid py-4">
// //                 <div className="card border-0 shadow-sm rounded-4">
// //                     <div className="card-header bg-white border-0 py-3">
// //                         <h4 className="fw-bold mb-3" style={{ color: '#064e3b' }}>Available Services</h4>
// //                         <div className="row g-3">
// //                             <div className="col-md-4">
// //                                 <input type="text" className="form-control" placeholder="Search services..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
// //                             </div>
// //                             <div className="col-md-4">
// //                                 <select className="form-select" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
// //                                     <option value="">All Categories</option>
// //                                     {categories.map(c => <option key={c.categoryId} value={c.name}>{c.name}</option>)}
// //                                 </select>
// //                             </div>
// //                             <div className="col-md-4">
// //                                 <select className="form-select" value={selectedSalon} onChange={(e) => setSelectedSalon(e.target.value)}>
// //                                     <option value="">All Salons</option>
// //                                     {salons.map(s => <option key={s.salonId} value={s.salonId}>{s.name}</option>)}
// //                                 </select>
// //                             </div>
// //                         </div>
// //                     </div>

// //                     <div className="card-body">
// //                         <div className="row g-4">
// //                             {filteredServices.map(service => (
// //                                 <div key={service.serviceTypeId} className="col-lg-4 col-md-6">
// //                                     <div className="card service-card h-100 border-0 shadow-sm p-3">
// //                                         <div className="d-flex justify-content-between mb-3">
// //                                             <div>
// //                                                 <h5 className="fw-bold text-dark mb-1">{service.name}</h5>
// //                                                 <Badge bg="light" text="dark" className="border">{service.category}</Badge>
// //                                             </div>
// //                                             <span className="fw-bold text-success">{formatPrice(service.price)}</span>
// //                                         </div>
// //                                         <div className="mb-3 text-muted small">
// //                                             <i className="ri-store-2-line me-1"></i> {service.salon?.name || 'Salon'}<br/>
// //                                             <i className="ri-time-line me-1"></i> {service.durationMinutes} mins
// //                                         </div>
// //                                         <button className="btn w-100 mt-auto fw-bold text-white" style={{ backgroundColor: THEME_COLOR }} onClick={() => handleBookClick(service)}>
// //                                             Book Appointment <i className="ri-calendar-line ms-2"></i>
// //                                         </button>
// //                                     </div>
// //                                 </div>
// //                             ))}
// //                         </div>
// //                     </div>
// //                 </div>

// //                 <Modal show={showBookingModal} onHide={() => { setShowBookingModal(false); setShowConfirmation(false); }} size="lg" centered backdrop="static">
// //                     <Modal.Header closeButton className="border-0">
// //                         <Modal.Title className="fw-bold" style={{ color: THEME_COLOR }}>
// //                             <i className="ri-calendar-check-line me-2"></i>
// //                             {showConfirmation ? 'Appointment Confirmed!' : 'Book Appointment'}
// //                         </Modal.Title>
// //                     </Modal.Header>
// //                     <Modal.Body>
// //                         {showConfirmation && bookingConfirmation ? (
// //                             <div className="confirmation-popup">
// //                                 <div className="text-center p-3">
// //                                     <div className="mb-4">
// //                                         <div className="d-inline-flex align-items-center justify-content-center rounded-circle" style={{ width: '80px', height: '80px', backgroundColor: '#d1fae5' }}>
// //                                             <i className="ri-checkbox-circle-fill" style={{ fontSize: '3rem', color: '#065f46' }}></i>
// //                                         </div>
// //                                     </div>
// //                                     <h4 className="fw-bold text-dark mb-3">Appointment Confirmed!</h4>
// //                                     <p className="text-success fw-bold mb-4">{bookingConfirmation.message}</p>
                                    
// //                                     <div className="card border-0 shadow-sm mb-4 bg-light text-start p-3">
// //                                         <div className="row">
// //                                             <div className="col-6 mb-2 small text-muted">Appointment No.</div>
// //                                             <div className="col-6 mb-2 fw-bold text-primary">{bookingConfirmation.appointmentNo}</div>
// //                                             <div className="col-6 mb-2 small text-muted">Service</div>
// //                                             <div className="col-6 mb-2 fw-bold">{bookingConfirmation.serviceName}</div>
// //                                             <div className="col-6 mb-2 small text-muted">Date & Time</div>
// //                                             <div className="col-6 mb-2 fw-bold">{bookingConfirmation.date} at {bookingConfirmation.time}</div>
// //                                         </div>
// //                                     </div>
// //                                     <Button variant="danger" className="px-5 rounded-pill" onClick={() => setShowBookingModal(false)}>Close</Button>
// //                                 </div>
// //                             </div>
// //                         ) : (
// //                             selectedService && (
// //                                 <div className="booking-container">
// //                                     {error && <Alert variant="danger" className="d-flex align-items-center"><i className="ri-error-warning-line me-2"></i>{error}</Alert>}

// //                                     <div className="service-summary p-3 mb-4 rounded-3 bg-light border">
// //                                         <div className="d-flex justify-content-between align-items-center">
// //                                             <div>
// //                                                 <h5 className="fw-bold text-dark mb-1">{selectedService.name}</h5>
// //                                                 <span className="text-muted small">{selectedService.salon?.name}</span>
// //                                             </div>
// //                                             <span className="fw-bold text-success">{formatPrice(selectedService.price)}</span>
// //                                         </div>
// //                                     </div>

// //                                     <form onSubmit={handleBookingSubmit}>
// //                                         <div className="customer-details mb-4">
// //                                             <h6 className="fw-bold mb-3"><i className="ri-user-line me-2"></i>{isLoggedIn ? 'Your Details' : 'Enter Your Details'}</h6>
// //                                             {isLoggedIn ? (
// //                                                 <div className="p-3 rounded-3 border bg-light">
// //                                                     <strong>{currentUser?.name}</strong><br/>
// //                                                     <span className="text-muted small">{currentUser?.email}</span>
// //                                                 </div>
// //                                             ) : (
// //                                                 <div className="row g-3">
// //                                                     <div className="col-md-6"><Form.Control placeholder="Full Name *" value={customerName} onChange={e => setCustomerName(e.target.value)} required /></div>
// //                                                     <div className="col-md-6"><Form.Control type="email" placeholder="Email *" value={customerEmail} onChange={e => setCustomerEmail(e.target.value)} required /></div>
// //                                                     <div className="col-md-6"><Form.Control placeholder="Phone Number" value={customerPhone} onChange={e => setCustomerPhone(e.target.value)} /></div>
// //                                                 </div>
// //                                             )}
// //                                         </div>

// //                                         <div className="row">
// //                                             <div className="col-lg-6 mb-4">
// //                                                 <h6 className="fw-bold mb-3">Select Date</h6>
// //                                                 <Calendar onChange={handleDateChange} value={selectedDate} minDate={new Date()} tileDisabled={tileDisabled} className="w-100 border-0" />
// //                                             </div>
// //                                             <div className="col-lg-6 mb-4">
// //                                                 <h6 className="fw-bold mb-3">Available Time Slots</h6>
// //                                                 <div className="row g-2 overflow-auto" style={{ maxHeight: '250px' }}>
// //                                                     {availableSlots.map((slot, i) => (
// //                                                         <div key={i} className="col-4">
// //                                                             <button type="button" 
// //                                                                 className={`btn btn-sm w-100 ${selectedTimeSlot === slot.value ? 'btn-primary' : slot.available ? 'btn-outline-primary' : 'btn-light'}`}
// //                                                                 disabled={!slot.available}
// //                                                                 onClick={() => setSelectedTimeSlot(slot.value)}>
// //                                                                 {slot.label}
// //                                                             </button>
// //                                                         </div>
// //                                                     ))}
// //                                                 </div>
// //                                             </div>
// //                                         </div>

// //                                         <Form.Control as="textarea" rows={2} className="mb-4" placeholder="Additional Notes (Optional)..." value={bookingNotes} onChange={e => setBookingNotes(e.target.value)} />

// //                                         <div className="modal-footer px-0 border-0">
// //                                             <Button variant="light" onClick={() => setShowBookingModal(false)}>Cancel</Button>
// //                                             <Button type="submit" style={{ backgroundColor: THEME_COLOR }} className="text-white px-4" disabled={!selectedTimeSlot || bookingLoading}>
// //                                                 {bookingLoading ? 'Processing...' : 'Confirm Appointment'}
// //                                             </Button>
// //                                         </div>
// //                                     </form>
// //                                 </div>
// //                             )
// //                         )}
// //                     </Modal.Body>
// //                 </Modal>
// //             </div>
// //         </div>
// //     );
// // };

// // export default BookService;
// //web view



// import React, { useState, useEffect } from 'react';
// import { Modal, Button, Form, Alert, Badge } from 'react-bootstrap';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import config from '../../Common/Configurations/APIConfig';
// import DefaultData from '../../Common/CompanyData/DefaultData';
// import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';
// import './BookService.css';

// const BookService = () => {
//     const [searchParams] = useSearchParams();
//     const navigate = useNavigate(); // Added for Mobile UX
    
//     // ================= DATA STATES =================
//     const [services, setServices] = useState([]);
//     const [filteredServices, setFilteredServices] = useState([]);
//     const [categories, setCategories] = useState([]);
//     const [salons, setSalons] = useState([]);
    
//     // ================= FILTER STATES =================
//     const [selectedCategory, setSelectedCategory] = useState('');
//     const [selectedSalon, setSelectedSalon] = useState('');
//     const [searchTerm, setSearchTerm] = useState('');
    
//     // ================= BOOKING MODAL STATES =================
//     const [showBookingModal, setShowBookingModal] = useState(false);
//     const [selectedService, setSelectedService] = useState(null);
//     const [selectedDate, setSelectedDate] = useState(new Date());
//     const [availableSlots, setAvailableSlots] = useState([]);
//     const [selectedTimeSlot, setSelectedTimeSlot] = useState(''); 
//     const [bookingNotes, setBookingNotes] = useState('');
//     const [bookingLoading, setBookingLoading] = useState(false);
    
//     // ================= CUSTOMER STATES =================
//     const [customerName, setCustomerName] = useState('');
//     const [customerEmail, setCustomerEmail] = useState('');
//     const [customerPhone, setCustomerPhone] = useState('');
//     const [isLoggedIn, setIsLoggedIn] = useState(false);
//     const [currentUser, setCurrentUser] = useState(null);
    
//     // ================= FEEDBACK STATES =================
//     const [error, setError] = useState('');
//     const [showConfirmation, setShowConfirmation] = useState(false);
//     const [bookingConfirmation, setBookingConfirmation] = useState(null);

//     const THEME_COLOR = '#065f46';
//     const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

//     // ================= INITIAL LOAD =================
//     useEffect(() => {
//         const salonIdFromUrl = searchParams.get('salonId');
//         if (salonIdFromUrl) {
//             setSelectedSalon(salonIdFromUrl);
//         }
//         checkAuthStatus();
//         fetchServices();
//         fetchCategories();
//         fetchSalons();
//     }, [searchParams]);

//     useEffect(() => {
//         filterServices();
//     }, [selectedCategory, selectedSalon, searchTerm, services]);

//     const checkAuthStatus = () => {
//         const token = localStorage.getItem('token');
//         const user = localStorage.getItem('user');
//         if (token && user) {
//             setIsLoggedIn(true);
//             const parsedUser = JSON.parse(user);
//             setCurrentUser(parsedUser);
//             setCustomerName(parsedUser.name || '');
//             setCustomerEmail(parsedUser.email || '');
//         } else {
//             setIsLoggedIn(false);
//             setCurrentUser(null);
//         }
//     };

//     const fetchServices = async () => {
//         try {
//             const res = await axios.get(config.APIACTIVEURL + config.GETSERVICETYPE);
//             if (res.data && res.data.data) {
//                 setServices(res.data.data.filter(s => s.isActive));
//             }
//         } catch (error) { console.error("Error fetching services", error); }
//     };

//     const fetchCategories = async () => {
//         try {
//             const res = await axios.get(config.APIACTIVEURL + config.GETALLCATEGORIES);
//             setCategories(res.data || []);
//         } catch (error) { console.error("Error fetching categories", error); }
//     };

//     const fetchSalons = async () => {
//         try {
//             const res = await axios.get(config.APIACTIVEURL + "Salon/GetAll");
//             setSalons(res.data || []);
//         } catch (error) { console.error("Error fetching salons", error); }
//     };

//     const filterServices = () => {
//         let filtered = [...services];
//         if (selectedCategory) filtered = filtered.filter(s => s.category === selectedCategory);
//         if (selectedSalon) {
//             filtered = filtered.filter(s => String(s.salonId).toLowerCase() === String(selectedSalon).toLowerCase());
//         }
//         if (searchTerm) {
//             const term = searchTerm.toLowerCase();
//             filtered = filtered.filter(s => 
//                 s.name.toLowerCase().includes(term) || s.category.toLowerCase().includes(term)
//             );
//         }
//         setFilteredServices(filtered);
//     };

//     const handleBookClick = async (service) => {
//         setSelectedService(service);
//         setError('');
//         setShowConfirmation(false);
//         setBookingConfirmation(null);
//         if (!isLoggedIn) {
//             setCustomerName(''); setCustomerEmail(''); setCustomerPhone('');
//         }
//         await fetchAvailableTimeSlots(service.serviceTypeId, new Date());
//         setShowBookingModal(true);
//     };

//     const fetchAvailableTimeSlots = async (serviceId, date) => {
//         setAvailableSlots(generateDemoSlots());
//     };

//     const generateDemoSlots = () => {
//         const slots = [];
//         for (let hour = 9; hour < 20; hour++) {
//             for (let minute of [0, 30]) {
//                 const h24 = hour.toString().padStart(2, '0');
//                 const m = minute.toString().padStart(2, '0');
//                 const time24 = `${h24}:${m}`;
//                 const period = hour >= 12 ? 'PM' : 'AM';
//                 const h12 = hour % 12 || 12;
//                 const time12 = `${h12.toString().padStart(2, '0')}:${m} ${period}`;

//                 slots.push({ 
//                     value: time24, 
//                     label: time12, 
//                     available: Math.random() > 0.3 
//                 });
//             }
//         }
//         return slots;
//     };

//     const handleDateChange = async (date) => {
//         setSelectedDate(date);
//         if (selectedService) {
//             await fetchAvailableTimeSlots(selectedService.serviceTypeId, date);
//         }
//     };

//     const validateCustomerDetails = () => {
//         if (!isLoggedIn) {
//             if (!customerName.trim()) { setError('Please enter your name'); return false; }
//             if (!customerEmail.trim()) { setError('Please enter your email'); return false; }
//             const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//             if (!emailRegex.test(customerEmail)) { setError('Please enter a valid email'); return false; }
//         }
//         return true;
//     };

//     const formatToNaiveISO = (date, timeSlot) => {
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const day = String(date.getDate()).padStart(2, '0');
//         return `${year}-${month}-${day}T${timeSlot}:00`;
//     };

//     const handleBookingSubmit = async (e) => {
//         e.preventDefault();
//         setError('');
//         if (!validateCustomerDetails()) return;
//         if (!selectedTimeSlot) { setError('Please select a time slot'); return; }

//         setBookingLoading(true);
//         try {
//             const startStr = formatToNaiveISO(selectedDate, selectedTimeSlot);
//             const [h, m] = selectedTimeSlot.split(':').map(Number);
//             const dateCopy = new Date(selectedDate);
//             dateCopy.setHours(h, m, 0, 0);
//             const endDateObj = new Date(dateCopy.getTime() + (selectedService.durationMinutes || 60) * 60000);
//             const endStr = formatToNaiveISO(endDateObj, `${String(endDateObj.getHours()).padStart(2, '0')}:${String(endDateObj.getMinutes()).padStart(2, '0')}`);

//             const bookingData = {
//                 salonId: selectedService.salonId,
//                 serviceTypeId: selectedService.serviceTypeId,
//                 startTime: startStr,
//                 endTime: endStr,
//                 status: "PENDING",
//                 email: isLoggedIn ? currentUser.email : customerEmail,
//                 customerName: isLoggedIn ? currentUser.name : customerName,
//                 notes: bookingNotes,
//                 ...(customerPhone && { phoneNumber: customerPhone })
//             };

//             const response = await axios.post(`${config.APIACTIVEURL}${config.CREATEAPPPOINTMENT}`, bookingData);
            
//             if (response.data.success) {
//                 const appointmentData = response.data.data;
//                 const displayTime = availableSlots.find(s => s.value === selectedTimeSlot)?.label || selectedTimeSlot;
//                 const bookingDetails = {
//                     appointmentNo: appointmentData?.appointmentNo || 'N/A',
//                     serviceName: selectedService.name,
//                     salonName: appointmentData?.salonName || selectedService.salon?.name || 'Salon',
//                     staffName: appointmentData?.staffName || 'Not assigned',
//                     date: selectedDate.toLocaleDateString(),
//                     time: displayTime,
//                     duration: selectedService.durationMinutes,
//                     price: selectedService.price,
//                     customerName: appointmentData?.customerName || (isLoggedIn ? currentUser.name : customerName),
//                     customerEmail: appointmentData?.customerEmail || (isLoggedIn ? currentUser.email : customerEmail),
//                     status: appointmentData?.status || 'PENDING',
//                     message: response.data.message || 'Appointment booked successfully!'
//                 };
//                 setBookingConfirmation(bookingDetails);
//                 setShowConfirmation(true);
//                 resetBookingForm();
//             } else {
//                 setError(response.data.message || 'Failed to create appointment');
//             }
//         } catch (error) {
//             setError(error.response?.data?.message || 'An error occurred. Please try again.');
//         } finally {
//             setBookingLoading(false);
//         }
//     };

//     const resetBookingForm = () => {
//         setSelectedTimeSlot(''); setBookingNotes(''); setSelectedDate(new Date());
//         setCustomerName(''); setCustomerEmail(''); setCustomerPhone(''); setError('');
//     };

//     const formatPrice = (price) => `${currency} ${price?.toFixed(2) || '0.00'}`;
//     const tileDisabled = ({ date, view }) => view === 'month' && date < new Date().setHours(0,0,0,0);

//     return (
//         <div className="page-content" style={{ paddingTop: "80px" }}>
//             <div className="container-fluid py-3">
                
//                 {/* Mobile UX Navigation */}
//                 <div className="d-flex align-items-center mb-3">
//                     <button 
//                         className="btn btn-light btn-sm rounded-pill me-3 shadow-sm border"
//                         onClick={() => navigate(-1)}
//                     >
//                         <i className="ri-arrow-left-line me-1"></i> Back
//                     </button>
//                     <h4 className="fw-bold mb-0 text-dark">Book Service</h4>
//                 </div>

//                 <div className="card border-0 shadow-sm rounded-4">
//                     <div className="card-header bg-white border-0 py-3">
//                         <div className="row g-2">
//                             {/* Filters: col-12 for full width on mobile, col-md-4 for row on desktop */}
//                             <div className="col-12 col-md-4">
//                                 <input type="text" className="form-control" placeholder="Search services..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
//                             </div>
//                             <div className="col-12 col-md-4">
//                                 <select className="form-select" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
//                                     <option value="">All Categories</option>
//                                     {categories.map(c => <option key={c.categoryId} value={c.name}>{c.name}</option>)}
//                                 </select>
//                             </div>
//                             <div className="col-12 col-md-4">
//                                 <select className="form-select" value={selectedSalon} onChange={(e) => setSelectedSalon(e.target.value)}>
//                                     <option value="">All Salons</option>
//                                     {salons.map(s => <option key={s.salonId} value={s.salonId}>{s.name}</option>)}
//                                 </select>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="card-body">
//                         <div className="row g-3">
//                             {filteredServices.map(service => (
//                                 <div key={service.serviceTypeId} className="col-12 col-md-6 col-lg-4">
//                                     <div className="card service-card h-100 border shadow-sm p-3">
//                                         <div className="d-flex justify-content-between mb-2">
//                                             <h6 className="fw-bold text-dark mb-0">{service.name}</h6>
//                                             <span className="fw-bold text-success small">{formatPrice(service.price)}</span>
//                                         </div>
//                                         <Badge bg="light" text="dark" className="border mb-3 w-fit-content">{service.category}</Badge>
//                                         <div className="mb-3 text-muted extra-small">
//                                             <i className="ri-store-2-line me-1"></i> {service.salon?.name || 'Salon'}<br/>
//                                             <i className="ri-time-line me-1"></i> {service.durationMinutes} mins
//                                         </div>
//                                         <button className="btn w-100 mt-auto fw-bold text-white py-2" style={{ backgroundColor: THEME_COLOR }} onClick={() => handleBookClick(service)}>
//                                             Book Now <i className="ri-calendar-line ms-2"></i>
//                                         </button>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>

//                 <Modal show={showBookingModal} onHide={() => { setShowBookingModal(false); setShowConfirmation(false); }} size="lg" centered backdrop="static">
//                     <Modal.Header closeButton className="border-0">
//                         <Modal.Title className="fw-bold h5" style={{ color: THEME_COLOR }}>
//                             {showConfirmation ? 'Confirmed!' : 'Select Date & Time'}
//                         </Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body className="pt-0">
//                         {showConfirmation && bookingConfirmation ? (
//                             <div className="text-center p-2">
//                                 <div className="mb-3">
//                                     <i className="ri-checkbox-circle-fill" style={{ fontSize: '3rem', color: '#065f46' }}></i>
//                                 </div>
//                                 <h5 className="fw-bold mb-4">Appointment Confirmed</h5>
//                                 <div className="card border-0 bg-light p-3 text-start mb-4">
//                                     <div className="row g-2">
//                                         <div className="col-5 small text-muted">ID:</div>
//                                         <div className="col-7 small fw-bold text-primary">{bookingConfirmation.appointmentNo}</div>
//                                         <div className="col-5 small text-muted">Service:</div>
//                                         <div className="col-7 small fw-bold">{bookingConfirmation.serviceName}</div>
//                                         <div className="col-5 small text-muted">When:</div>
//                                         <div className="col-7 small fw-bold">{bookingConfirmation.date} @ {bookingConfirmation.time}</div>
//                                     </div>
//                                 </div>
//                                 <Button variant="danger" className="w-100 rounded-pill" onClick={() => setShowBookingModal(false)}>Close</Button>
//                             </div>
//                         ) : (
//                             selectedService && (
//                                 <div className="booking-container">
//                                     {error && <Alert variant="danger" className="py-2 small mb-3">{error}</Alert>}
//                                     <form onSubmit={handleBookingSubmit}>
//                                         <div className="row">
//                                             <div className="col-12 col-lg-6 mb-3">
//                                                 <h6 className="fw-bold mb-2 small">1. Choose Date</h6>
//                                                 <div className="calendar-wrapper border rounded p-1 bg-white">
//                                                     <Calendar onChange={handleDateChange} value={selectedDate} minDate={new Date()} tileDisabled={tileDisabled} className="w-100 border-0" />
//                                                 </div>
//                                             </div>
//                                             <div className="col-12 col-lg-6 mb-3">
//                                                 <h6 className="fw-bold mb-2 small">2. Choose Time</h6>
//                                                 <div className="row g-2 overflow-auto" style={{ maxHeight: '200px', paddingRight: '5px' }}>
//                                                     {availableSlots.map((slot, i) => (
//                                                         <div key={i} className="col-4">
//                                                             <button type="button" 
//                                                                 className={`btn btn-sm w-100 py-2 extra-small ${selectedTimeSlot === slot.value ? 'btn-primary' : slot.available ? 'btn-outline-primary' : 'btn-light'}`}
//                                                                 disabled={!slot.available}
//                                                                 onClick={() => setSelectedTimeSlot(slot.value)}>
//                                                                 {slot.label}
//                                                             </button>
//                                                         </div>
//                                                     ))}
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="customer-info border-top pt-3 mb-3">
//                                             <h6 className="fw-bold mb-2 small">3. Your Info</h6>
//                                             {isLoggedIn ? (
//                                                 <div className="bg-light p-2 rounded small"><strong>{currentUser?.name}</strong> ({currentUser?.email})</div>
//                                             ) : (
//                                                 <div className="row g-2">
//                                                     <div className="col-12"><Form.Control size="sm" placeholder="Full Name *" value={customerName} onChange={e => setCustomerName(e.target.value)} required /></div>
//                                                     <div className="col-12"><Form.Control size="sm" type="email" placeholder="Email *" value={customerEmail} onChange={e => setCustomerEmail(e.target.value)} required /></div>
//                                                 </div>
//                                             )}
//                                         </div>

//                                         <Form.Control as="textarea" rows={2} className="mb-3 small" placeholder="Notes (Optional)..." value={bookingNotes} onChange={e => setBookingNotes(e.target.value)} />

//                                         <div className="d-flex gap-2">
//                                             <Button variant="light" className="flex-grow-1" onClick={() => setShowBookingModal(false)}>Cancel</Button>
//                                             <Button type="submit" style={{ backgroundColor: THEME_COLOR }} className="text-white flex-grow-1" disabled={!selectedTimeSlot || bookingLoading}>
//                                                 {bookingLoading ? 'Processing...' : 'Confirm'}
//                                             </Button>
//                                         </div>
//                                     </form>
//                                 </div>
//                             )
//                         )}
//                     </Modal.Body>
//                 </Modal>
//             </div>
//         </div>
//     );
// };

// export default BookService;










import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert, Badge, Container, Row, Col } from 'react-bootstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './BookService.css';

const BookService = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    
    const [services, setServices] = useState([]);
    const [filteredServices, setFilteredServices] = useState([]);
    const [categories, setCategories] = useState([]);
    const [salons, setSalons] = useState([]);
    
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSalon, setSelectedSalon] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [availableSlots, setAvailableSlots] = useState([]);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(''); 
    const [bookingNotes, setBookingNotes] = useState('');
    const [bookingLoading, setBookingLoading] = useState(false);
    
    const [customerName, setCustomerName] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    
    const [error, setError] = useState('');
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [bookingConfirmation, setBookingConfirmation] = useState(null);

    const THEME_COLOR = '#065f46';
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

    useEffect(() => {
        const salonIdFromUrl = searchParams.get('salonId');
        if (salonIdFromUrl) setSelectedSalon(salonIdFromUrl);
        checkAuthStatus();
        fetchServices();
        fetchCategories();
        fetchSalons();
    }, [searchParams]);

    useEffect(() => {
        filterServices();
    }, [selectedCategory, selectedSalon, searchTerm, services]);

    const checkAuthStatus = () => {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');
        if (token && user) {
            setIsLoggedIn(true);
            const parsedUser = JSON.parse(user);
            setCurrentUser(parsedUser);
            setCustomerName(parsedUser.name || '');
            setCustomerEmail(parsedUser.email || '');
        } else {
            setIsLoggedIn(false);
            setCurrentUser(null);
        }
    };

    const fetchServices = async () => {
        try {
            const res = await axios.get(config.APIACTIVEURL + config.GETSERVICETYPE);
            if (res.data && res.data.data) {
                setServices(res.data.data.filter(s => s.isActive));
            }
        } catch (error) { console.error("Error fetching services", error); }
    };

    const fetchCategories = async () => {
        try {
            const res = await axios.get(config.APIACTIVEURL + config.GETALLCATEGORIES);
            setCategories(res.data || []);
        } catch (error) { console.error("Error fetching categories", error); }
    };

    const fetchSalons = async () => {
        try {
            const res = await axios.get(config.APIACTIVEURL + "Salon/GetAll");
            setSalons(res.data || []);
        } catch (error) { console.error("Error fetching salons", error); }
    };

    const filterServices = () => {
        let filtered = [...services];
        if (selectedCategory) filtered = filtered.filter(s => s.category === selectedCategory);
        if (selectedSalon) {
            filtered = filtered.filter(s => String(s.salonId).toLowerCase() === String(selectedSalon).toLowerCase());
        }
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(s => 
                s.name.toLowerCase().includes(term) || s.category.toLowerCase().includes(term)
            );
        }
        setFilteredServices(filtered);
    };

    const handleBookClick = async (service) => {
        setSelectedService(service);
        setError('');
        setShowConfirmation(false);
        setBookingConfirmation(null);
        if (!isLoggedIn) {
            setCustomerName(''); setCustomerEmail(''); setCustomerPhone('');
        }
        await fetchAvailableTimeSlots(service.serviceTypeId, new Date());
        setShowBookingModal(true);
    };

    const fetchAvailableTimeSlots = async (serviceId, date) => {
        setAvailableSlots(generateDemoSlots());
    };

    const generateDemoSlots = () => {
        const slots = [];
        for (let hour = 9; hour < 20; hour++) {
            for (let minute of [0, 30]) {
                const h24 = hour.toString().padStart(2, '0');
                const m = minute.toString().padStart(2, '0');
                const time24 = `${h24}:${m}`;
                const period = hour >= 12 ? 'PM' : 'AM';
                const h12 = hour % 12 || 12;
                const time12 = `${h12.toString().padStart(2, '0')}:${m} ${period}`;
                slots.push({ value: time24, label: time12, available: Math.random() > 0.3 });
            }
        }
        return slots;
    };

    const handleDateChange = async (date) => {
        setSelectedDate(date);
        if (selectedService) await fetchAvailableTimeSlots(selectedService.serviceTypeId, date);
    };

    const formatToNaiveISO = (date, timeSlot) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}T${timeSlot}:00`;
    };

    const handleBookingSubmit = async (e) => {
        e.preventDefault();
        if (!isLoggedIn && (!customerName.trim() || !customerEmail.trim())) {
            setError('Please fill required details'); return;
        }
        if (!selectedTimeSlot) { setError('Please select a time slot'); return; }

        setBookingLoading(true);
        try {
            const startStr = formatToNaiveISO(selectedDate, selectedTimeSlot);
            const [h, m] = selectedTimeSlot.split(':').map(Number);
            const dateCopy = new Date(selectedDate);
            dateCopy.setHours(h, m, 0, 0);
            const endDateObj = new Date(dateCopy.getTime() + (selectedService.durationMinutes || 60) * 60000);
            const endStr = formatToNaiveISO(endDateObj, `${String(endDateObj.getHours()).padStart(2, '0')}:${String(endDateObj.getMinutes()).padStart(2, '0')}`);

            const bookingData = {
                salonId: selectedService.salonId,
                serviceTypeId: selectedService.serviceTypeId,
                startTime: startStr,
                endTime: endStr,
                status: "PENDING",
                email: isLoggedIn ? currentUser.email : customerEmail,
                customerName: isLoggedIn ? currentUser.name : customerName,
                notes: bookingNotes,
                ...(customerPhone && { phoneNumber: customerPhone })
            };

            const response = await axios.post(`${config.APIACTIVEURL}${config.CREATEAPPPOINTMENT}`, bookingData);
            if (response.data.success) {
                const appointmentData = response.data.data;
                const displayTime = availableSlots.find(s => s.value === selectedTimeSlot)?.label || selectedTimeSlot;
                setBookingConfirmation({
                    appointmentNo: appointmentData?.appointmentNo || 'N/A',
                    serviceName: selectedService.name,
                    date: selectedDate.toLocaleDateString(),
                    time: displayTime,
                    message: response.data.message || 'Booked successfully!'
                });
                setShowConfirmation(true);
                resetBookingForm();
            } else { setError(response.data.message); }
        } catch (error) { setError('Booking failed. Try again.'); } finally { setBookingLoading(false); }
    };

    const resetBookingForm = () => {
        setSelectedTimeSlot(''); setBookingNotes(''); setSelectedDate(new Date());
        setCustomerName(''); setCustomerEmail(''); setCustomerPhone(''); setError('');
    };

    const formatPrice = (price) => `${currency} ${price?.toFixed(2) || '0.00'}`;

    return (
        <div className="page-content booking-page-wrapper">
            <Container fluid className="py-3 py-md-4">
                <div className="card border-0 shadow-sm rounded-4">
                    <div className="card-header bg-white border-0 py-3">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <Button variant="light" size="sm" onClick={() => navigate(-1)} className="rounded-pill px-3 border">
                                <i className="ri-arrow-left-line"></i> Back
                            </Button>
                            <h4 className="fw-bold mb-0 text-dark">Book Service</h4>
                        </div>
                        <Row className="g-2 g-md-3 filter-section">
                            <Col xs={12} md={4}>
                                <div className="input-group">
                                    <span className="input-group-text bg-white border-end-0"><i className="ri-search-line text-muted"></i></span>
                                    <input type="text" className="form-control border-start-0" placeholder="Search services..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                                </div>
                            </Col>
                            <Col xs={6} md={4}>
                                <select className="form-select custom-select-style" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                                    <option value="">All Categories</option>
                                    {categories.map(c => <option key={c.categoryId} value={c.name}>{c.name}</option>)}
                                </select>
                            </Col>
                            <Col xs={6} md={4}>
                                <select className="form-select custom-select-style" value={selectedSalon} onChange={(e) => setSelectedSalon(e.target.value)}>
                                    <option value="">All Salons</option>
                                    {salons.map(s => <option key={s.salonId} value={s.salonId}>{s.name}</option>)}
                                </select>
                            </Col>
                        </Row>
                    </div>

                    <div className="card-body">
                        <Row className="g-3 g-md-4">
                            {filteredServices.length === 0 ? (
                                <Col xs={12} className="text-center py-5 text-muted">No services found match your filters.</Col>
                            ) : (
                                filteredServices.map(service => (
                                    <Col key={service.serviceTypeId} xs={12} md={6} lg={4}>
                                        <div className="card service-card h-100 border rounded-3 p-3 shadow-sm">
                                            <div className="d-flex justify-content-between mb-2">
                                                <h5 className="fw-bold text-dark mb-0 fs-6 fs-md-5">{service.name}</h5>
                                                <span className="fw-bold text-success small">{formatPrice(service.price)}</span>
                                            </div>
                                            <Badge bg="light" text="dark" className="border mb-3 align-self-start">{service.category}</Badge>
                                            <div className="mb-3 text-muted small">
                                                <div className="mb-1"><i className="ri-store-2-line me-1"></i> {service.salon?.name || 'Salon'}</div>
                                                <div><i className="ri-time-line me-1"></i> {service.durationMinutes} mins</div>
                                            </div>
                                            <button className="btn w-100 mt-auto fw-bold text-white btn-sm btn-md-md" style={{ backgroundColor: THEME_COLOR }} onClick={() => handleBookClick(service)}>
                                                Book Now <i className="ri-calendar-line ms-1"></i>
                                            </button>
                                        </div>
                                    </Col>
                                ))
                            )}
                        </Row>
                    </div>
                </div>

                <Modal show={showBookingModal} onHide={() => { setShowBookingModal(false); setShowConfirmation(false); }} size="lg" centered backdrop="static" className="booking-modal-mobile">
                    <Modal.Header closeButton className="border-0">
                        <Modal.Title className="fw-bold fs-5" style={{ color: THEME_COLOR }}>
                            <i className="ri-calendar-check-line me-2"></i>
                            {showConfirmation ? 'Booking Success' : 'Book Appointment'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-0">
                        {showConfirmation && bookingConfirmation ? (
                            <div className="text-center py-3">
                                <div className="mb-3 text-success"><i className="ri-checkbox-circle-fill fs-1"></i></div>
                                <h5 className="fw-bold mb-3">{bookingConfirmation.message}</h5>
                                <div className="bg-light p-3 rounded-3 text-start small mb-4">
                                    <p className="mb-1"><strong>ID:</strong> {bookingConfirmation.appointmentNo}</p>
                                    <p className="mb-1"><strong>Service:</strong> {bookingConfirmation.serviceName}</p>
                                    <p className="mb-0"><strong>Time:</strong> {bookingConfirmation.date} @ {bookingConfirmation.time}</p>
                                </div>
                                <Button variant="danger" className="w-100 rounded-pill" onClick={() => setShowBookingModal(false)}>Close</Button>
                            </div>
                        ) : selectedService && (
                            <div className="booking-form-wrapper">
                                {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}
                                <div className="bg-light p-3 rounded-3 mb-3 border d-flex justify-content-between">
                                    <span className="fw-bold small">{selectedService.name}</span>
                                    <span className="text-success fw-bold small">{formatPrice(selectedService.price)}</span>
                                </div>

                                <form onSubmit={handleBookingSubmit}>
                                    {!isLoggedIn && (
                                        <Row className="g-2 mb-3">
                                            <Col xs={12}><Form.Control size="sm" placeholder="Name *" value={customerName} onChange={e => setCustomerName(e.target.value)} required /></Col>
                                            <Col xs={12} md={6}><Form.Control size="sm" type="email" placeholder="Email *" value={customerEmail} onChange={e => setCustomerEmail(e.target.value)} required /></Col>
                                            <Col xs={12} md={6}><Form.Control size="sm" placeholder="Phone" value={customerPhone} onChange={e => setCustomerPhone(e.target.value)} /></Col>
                                        </Row>
                                    )}
                                    <Row>
                                        <Col xs={12} lg={6} className="mb-3">
                                            <h6 className="fw-bold small mb-2">Select Date</h6>
                                            <div className="calendar-responsive-wrapper">
                                                <Calendar onChange={handleDateChange} value={selectedDate} minDate={new Date()} className="w-100 border rounded-3" />
                                            </div>
                                        </Col>
                                        <Col xs={12} lg={6} className="mb-3">
                                            <h6 className="fw-bold small mb-2">Available Times</h6>
                                            <div className="time-slots-grid">
                                                {availableSlots.map((slot, i) => (
                                                    <button key={i} type="button" 
                                                        className={`time-slot-item ${selectedTimeSlot === slot.value ? 'active' : slot.available ? '' : 'disabled'}`}
                                                        disabled={!slot.available}
                                                        onClick={() => setSelectedTimeSlot(slot.value)}>
                                                        {slot.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Form.Control as="textarea" rows={2} className="mb-3 small" placeholder="Notes..." value={bookingNotes} onChange={e => setBookingNotes(e.target.value)} />
                                    <div className="d-flex gap-2">
                                        <Button variant="light" className="flex-grow-1 small" onClick={() => setShowBookingModal(false)}>Cancel</Button>
                                        <Button type="submit" style={{ backgroundColor: THEME_COLOR }} className="flex-grow-1 text-white small" disabled={!selectedTimeSlot || bookingLoading}>
                                            {bookingLoading ? '...' : 'Confirm'}
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        )}
                    </Modal.Body>
                </Modal>
            </Container>
        </div>
    );
};

export default BookService;